import type { AppProps } from "next/app";
import Head from "next/head";
import { FontStyle } from "@swiggy-private/dls-web-theme/dist/components/Fonts";
import ErrorBoundary from "@swiggy-private/aatm-nirbhar-ui/dist/ErrorBoundary";
import GlobalStyled from "@swiggy-private/aatm-nirbhar-ui/dist/GlobalStyled";
import { ThemeProvider } from "@swiggy-private/dls-web-theme/dist/components/ThemeProvider";
import { BaseTheme } from "@swiggy-private/dls-web-common/dist/components/themes/Base";
import { useBootstrap } from "hooks/useBootstrap";
import { GlobalStyles } from "styles/globals";
import { ShuttleAppName } from "styles/home";
import { Container } from "styles/page";
import { AuthProvider } from "components/Auth";
import { OnboardingProvider } from "contexts/OnboardingContext";
import { AnalyticsProvider } from "contexts/AnalyticsContext";
import { useAnalyticsRouteTracking } from "hooks/useAnalyticsRouteTracking";

// Component to handle analytics route tracking (needs to be inside AuthProvider)
const AnalyticsRouteTracker = () => {
    useAnalyticsRouteTracking();
    return null;
};

function MyApp({ Component, pageProps }: AppProps) {
    useBootstrap("influencer_web");

    return (
        <>
            {/* @ts-ignore Next.js Head component type compatibility */}
            <Head>
                <meta charSet="UTF-8" />
                <meta
                    name="viewport"
                    content="viewport-fit=cover, width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
                />
                <meta name="format-detection" content="telephone=no" />
                <meta name="x-apple-data-detectors" content="off" />
                <link rel="icon" href="https://driver-media-assets.swiggy.com/influencer-app-assets/favicon/favicon.ico" />
                <link rel="icon" type="image/svg+xml" href="https://driver-media-assets.swiggy.com/influencer-app-assets/favicon/favicon.svg" />
                <link rel="icon" type="image/png" sizes="96x96" href="https://driver-media-assets.swiggy.com/influencer-app-assets/favicon/favicon-96x96.png" />
                <link rel="apple-touch-icon" href="https://driver-media-assets.swiggy.com/influencer-app-assets/favicon/apple-touch-icon.png" />
                <link rel="manifest" href="/site.webmanifest" />
                <link rel="preconnect" href={process.env.NEXT_PUBLIC_CDN_URL} crossOrigin="anonymous" />
                <link rel="dns-prefetch" href={process.env.NEXT_PUBLIC_CDN_URL} />
                <link rel="preconnect" href="https://driver-media-assets.swiggy.com" crossOrigin="anonymous" />
                <link rel="dns-prefetch" href="https://driver-media-assets.swiggy.com" />
            </Head>
            {/* @ts-ignore ErrorBoundary component type compatibility */}
            <ErrorBoundary dsn="">
                {/* @ts-ignore ThemeProvider component type compatibility */}
                <ThemeProvider theme={BaseTheme} colorMode="light">
                    {/* @ts-ignore ShuttleAppName component type compatibility */}
                    <ShuttleAppName data-app-name={`${process.env.NEXT_PUBLIC_APP_NAME}`} />

                    {/* @ts-ignore GlobalStyled component type compatibility */}
                    <GlobalStyled />

                    {/* @ts-ignore GlobalStyles component type compatibility */}
                    <GlobalStyles />
                    {/* @ts-ignore FontStyle component type compatibility */}
                    <FontStyle />
                    {/* @ts-ignore DLS types */}
                    <AuthProvider>
                        <AnalyticsProvider>
                            <AnalyticsRouteTracker />
                            <OnboardingProvider>
                                <Container>
                                    <Component {...pageProps} />
                                </Container>
                            </OnboardingProvider>
                        </AnalyticsProvider>
                    </AuthProvider>
                </ThemeProvider>
            </ErrorBoundary>
        </>
    );
}

export default MyApp;
